import { render, staticRenderFns } from "./OrderActionModal.vue?vue&type=template&id=1c3612e6&scoped=true&"
import script from "./OrderActionModal.vue?vue&type=script&lang=js&"
export * from "./OrderActionModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderActionModal.vue?vue&type=style&index=0&id=1c3612e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3612e6",
  null
  
)

export default component.exports